export const calculateTotalPrice = (chosenBundleVariants) => {
    const variantPrices = Object.keys(chosenBundleVariants).map((key) => {
        const price = chosenBundleVariants[key];
        const amount = price?.priceV2?.amount;
        return amount ? parseFloat(amount) : 0;
    });

    return variantPrices.reduce((total, current) => total + current, 0);
};

export const calculateDiscountedAmount = (totalPrice, discountPercentage) => {
    return totalPrice - (totalPrice * discountPercentage) / 100;
};

export const formatPrice = (amount, currencySymbol) => {
    return `${currencySymbol}${amount.toFixed(2)}`;
};
